import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "tab-bar__sticky",
  ref: "stickyNav"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SectionNavigation = _resolveComponent("SectionNavigation")!
  const _component_FinishesBar = _resolveComponent("FinishesBar")!
  const _component_ProductGrid = _resolveComponent("ProductGrid")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_SectionNavigation, {
        translations: $setup.translations,
        groupBy: $setup.store?.getters?.groupBy,
        productTypes: $setup.store?.getters?.responseData?.data?.productTypes
      }, null, 8 /* PROPS */, ["translations", "groupBy", "productTypes"]),
      _createVNode(_component_FinishesBar, {
        translations: $setup.translations,
        groupBy: $setup.store?.getters?.groupBy,
        finishes: $setup.store.getters?.responseData?.data?.availableFinishes
      }, null, 8 /* PROPS */, ["translations", "groupBy", "finishes"])
    ], 512 /* NEED_PATCH */),
    _createVNode(_component_ProductGrid, {
      translations: $setup.translations,
      groupBy: $setup.store?.getters?.groupBy,
      showWholesale: $setup.store.getters?.showWholesale,
      products: $setup.store?.getters.responseData?.data?.products,
      styles: $setup.store?.getters?.responseData?.data?.styles,
      productTypes: $setup.store?.getters?.responseData?.data?.productTypes
    }, null, 8 /* PROPS */, ["translations", "groupBy", "showWholesale", "products", "styles", "productTypes"])
  ], 64 /* STABLE_FRAGMENT */))
}